import { render } from "./TyreLabelling.vue?vue&type=template&id=4884b886"
import script from "./TyreLabelling.vue?vue&type=script&lang=js"
export * from "./TyreLabelling.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__